module.exports = __webpack_public_path__ + "img/image4.2a83d507.jpg";